<div class="product-item">
  <img class="icon" [src]="icon" alt="" aria-hidden="true" />
  <div class="ticket-info">
    <p class="product-name">
      <span class="ticket-id">#{{ ticket.id }} - </span>{{ ticket.product.name }}
    </p>

    @if (getLatestPetition(ticket); as petition) {
    <span
      class="petition-tag"
      [ngClass]="{
        'pending-edit': petition.status === 'pending' && petition.type === 'edit',
        'pending-delete': petition.status === 'pending' && petition.type === 'delete',
        approved: petition.status === 'approved',
        rejected: petition.status === 'rejected'
      }"
    >
      {{ getPetitionLabel(petition) }}
    </span>
    } @if (shouldShowReference(ticket)) {
    <p class="ticket-detail single-line">
      {{ "tickets-sold.reference" | translate }} {{ ticket.reference }}
    </p>
    } @if (ticket.fullname) {
    <p class="ticket-detail single-line">
      {{ "tickets-sold.buyer" | translate }} {{ ticket.fullname }}
    </p>
    } @if (ticket.ecommerce) {
    <div class="ticket-meta">
      @if (!isPayAtDoor(ticket)) {
      <span class="transaction-date">
        {{ ticket.latest_transaction?.created_at | date : "dd/MM HH:mm" }}
      </span>
      <span class="separator">-</span>
      <span class="payment-method">
        {{ getPaymentMethodLabel(ticket.payment_method) }}
      </span>
      } @else {
      <span class="payment-method-chip">
        {{ "payment-product-modal.collection-type.third-party" | translate }}
      </span>
      }
    </div>
    <div class="ticket-meta">
      <span class="price">{{ getPaidAmount(ticket) | arsCurrency }}</span>
      <span class="ticket-sold">
        <img src="assets/icons/ticket-qr-code.svg" class="ticket-qr" alt="" aria-hidden="true" />
        <span>{{ ticket.assistants_count }}/{{ ticket.quota }}</span>
      </span>
    </div>
    } @else {
    <!-- Venta directa: el tab ya dice el canal; solo "Boletería" agrega información. -->
    <div class="ticket-meta">
      @if (isPayAtDoor(ticket)) {
      <span class="payment-method-chip">
        {{ "payment-product-modal.collection-type.third-party" | translate }}
      </span>
      }
      <span class="price">{{ getTicketAmount(ticket) | arsCurrency }}</span>
      <span class="ticket-sold">
        <img src="assets/icons/ticket-qr-code.svg" class="ticket-qr" alt="" aria-hidden="true" />
        <span>{{ ticket.assistants_count }}/{{ ticket.quota }}</span>
      </span>
    </div>
    }
  </div>
  <button type="button" class="dropdown-button" (click)="openOptionsModal()">
    <ion-icon name="ellipsis-vertical" class="options-icon" aria-hidden="true" />
    <span class="visually-hidden">{{ "tickets-sold.options" | translate }}</span>
  </button>
</div>
